var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":_vm.color,"small":""}},[_vm._v("mdi-earth")])
}
var staticRenderFns = []

export { render, staticRenderFns }